import React from "react"

import { RadioCheckingSavings } from "@atos6/components"
import { useStore } from "../containers"

export function RadioCheckingSavingsStateful() {
  const { bankAccountType, setState } = useStore()

  return (
    <RadioCheckingSavings
      value={bankAccountType}
      onChange={bankAccountType => setState({ bankAccountType })}
    />
  )
}
